import React from 'react';
import { useField } from 'formik';
import styled, { css } from 'styled-components';

import { FormLabel as Label } from '~ui-kit';
import TextInput from '../components/TextInput';
import Error from '../components/Error';
import FieldContextFeeder from '../components/FieldContextFeeder';

const NumberField = ({ ...props }) => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <Container flat={props.flat}>
      <Label
        htmlFor={props.id || props.name}
        info={props.info}
        required={props.required}
      >
        {props.label}
      </Label>
      <TextInput
        {...field}
        {...props}
        error={error}
        type="number"
        maxWidth="80px"
      />
      {error ? <Error>{meta.error}</Error> : null}
    </Container>
  );
};

const Container = styled.div`
  ${p =>
    p.flat &&
    css`
      display: flex;
      align-items: center;
      white-space: nowrap;

      & > label {
        margin-bottom: 0;
        margin-right: 24px;
      }
    `}
`;

export default FieldContextFeeder(NumberField);
